<template>
	<section class="no-marginbottom">
		<h2>Stellungnahmen ({{ statements ? statements.length : 0 }})</h2>
	</section>
	<swiper
		v-if="isMobile"
		:direction="'horizontal'"
		:loop="false"
		:spaceBetween="20"
		:slides-per-view="statements && statements.length > 1 ? 1.25 : 1"
		:centeredSlides="false"
		:freeMode="{ enabled: false, sticky: false }"
		:mousewheel="true"
		:class="'slider--boxes'"
	>
		<swiper-slide v-for="item in statements" :key="item.hid">
			<BoxStatement :statement="item" />
		</swiper-slide>
	</swiper>
	<section v-else>
		<StatementsTable
			:tableData="statements ? statements : []"
			:totalCount="statements ? statements.length : 0"
			@loadNextPage="null"
			:shouldSeePersonalData="false"
		/>
	</section>
</template>

<script lang="ts">
import { defineComponent, computed, PropType } from 'vue';
import { useStore } from '@/store';
import { StatementResponse } from '../../types/types';
import BoxStatement from '@/components/boxes/BoxStatement.vue';
import StatementsTable from '@/components/tables/StatementsTable.vue';
import { Swiper, SwiperSlide } from 'swiper/vue';

export default defineComponent({
	name: 'SectionStatements',
	data() {
		return {};
	},
	props: {
		statements: {
			type: Array as PropType<StatementResponse[]>,
		},
	},
	setup() {
		const store = useStore();
		const isMobile = computed(() => store.state.isMobile);

		return {
			store,
			isMobile,
		};
	},
	components: {
		BoxStatement,
		StatementsTable,
		Swiper,
		SwiperSlide,
	},
});
</script>
